import { render } from "./WeekendClassFee.vue?vue&type=template&id=74b80f4c&scoped=true"
import script from "./WeekendClassFee.vue?vue&type=script&lang=js"
export * from "./WeekendClassFee.vue?vue&type=script&lang=js"

import "./WeekendClassFee.vue?vue&type=style&index=0&id=74b80f4c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b80f4c"]])

export default __exports__